<template>
  <div id="chart-div"></div>
</template>

<script>
import {Theme as am5themes_Animated} from "@amcharts/amcharts5";
import {RadarChart, RadarCursor} from "@amcharts/amcharts5/radar";
import * as am5radar from "@amcharts/amcharts5/radar";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5 from "@amcharts/amcharts5";

export default {
  components: {

  },
  props: {
    model: {
      type: Array,
      required: true,
      default: []
    }
  },
  data(){
    return {
    }
  },
  mounted() {
    this.createChart();
  },
  methods: {
    createChart() {
      const self = this;
      am5.ready(function () {
        // Create root element
        // https://www.amcharts.com/docs/v5/getting-started/#Root_element
        let root = am5.Root.new("chart-div");

        // Set themes
        // https://www.amcharts.com/docs/v5/concepts/themes/
        root.setThemes([
          am5themes_Animated.new(root)
        ]);

        // Create chart
        // https://www.amcharts.com/docs/v5/charts/radar-chart/
        let chart = root.container.children.push(RadarChart.new(root, {
          panX: false,
          panY: false,
          //wheelX: "panX",
          //wheelY: "zoomX",
          wheelX: "none",
          wheelY: "none"
        }));

        // Add cursor
        // https://www.amcharts.com/docs/v5/charts/radar-chart/#Cursor

        let cursor = chart.set("cursor", RadarCursor.new(root, {
          behavior: "none"
        }));

        cursor.lineY.set("visible", false);


        // Create axes and their renderers
        // https://www.amcharts.com/docs/v5/charts/radar-chart/#Adding_axes
        let xRenderer = am5radar.AxisRendererCircular.new(root, {});
        xRenderer.labels.template.setAll({
          radius: 10
        });

        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
          maxDeviation: 0,
          categoryField: "dimension",
          renderer: xRenderer,
          //tooltip: am5.Tooltip.new(root, {})
        }));

        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
          renderer: am5radar.AxisRendererRadial.new(root, {})
        }));


        // Create series
        // https://www.amcharts.com/docs/v5/charts/radar-chart/#Adding_series
        let series = chart.series.push(am5radar.RadarLineSeries.new(root, {
          name: "Series",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "score",
          categoryXField: "dimension",
          tooltip: am5.Tooltip.new(root, {labelText: "{valueY}"})
        }));

        series.strokes.template.setAll({
          strokeWidth: 2
        });

        series.bullets.push(function () {
          return am5.Bullet.new(root, {
            sprite: am5.Circle.new(root, {
              radius: 5,
              fill: series.get("fill")
            })
          });
        });

        // Set data
        // https://www.amcharts.com/docs/v5/charts/radar-chart/#Setting_data

        series.data.setAll(self.model);
        xAxis.data.setAll(self.model);

        // Animate chart and series in
        // https://www.amcharts.com/docs/v5/concepts/animations/#Initial_animation
        series.appear(1000);
        chart.appear(1000, 100);

      }); // end am5.ready()
    }
  },
}
</script>

<style scoped>
#chart-div {
  width: 100%;
  height: 500px;
}
</style>